import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { BanBody } from '../components/ban/BanBody';
import { ShopBody } from '../components/profile/ShopBody';
import useSession from '../hooks/useSession';
import { BASE_URL, BASE_IMG_URL } from '../const/ConstBase';
import { api } from '../services/api';
import { useNavigate } from 'react-router-dom';

import './ShopScreen.scss';

export const ShopScreen = () => {
    const { user } = useSession();
    const navigate = useNavigate();

    const fetchData = async () => {
        try {
            const response = await api.post('/shop/can_buy', {});
            return response.data;
        } catch (error) {
            // console.log(error);
        }
    };

    useEffect(() => {
        fetchData().then((res) => {
            console.log(res);
            if (res.code !== '10000') {
                // if (res.message === 'block_account') {
                //     alert('Due to being banned, you are unable to purchase.');
                // } else if (res.message === 'not_enough_level') {
                //     alert(
                //         'Your Aika Character Level must be 53 or higher to purchase M-coins'
                //     );
                // } else {
                //     alert('You are unable to purchase RC-Coins.');
                // }
                // navigate('/');
            }
        });
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='shop-page'>
            <Helmet>
                <title>Purchase RC-Coin</title>
                <meta name='description' content='Purchase RC-Coin' />
            </Helmet>
            <div
                className='shop-header'
                style={{
                    backgroundImage: `url(${BASE_IMG_URL}lutador_shop_main.webp)`,
                }}
            >
                <h1 className='shop-header-title'>LOJA DE CASH</h1>
                <p className='shop-header-desc'>
                    O RC que você comprou pode ser usado para adquirir itens na
                    loja do jogo.
                </p>
            </div>
            <ShopBody />
        </div>
    );
};
